import React from "react";


export const QuestionA2Parts = () => {

    return (
        <>
        <div className="select_content">
            <div className="select_desc">期間中に福岡県のLPガス販売店で下記の商品のいずれかを購入しましたか？</div>
        </div>
        <div className="mb-20"><img src={`${process.env.REACT_APP_HOME_URL}/images/gaskigu.jpg`} alt="ガス器具"/></div>
        <div className="mb-40">※対象店舗は店舗選択画面で確認できます</div>
        </>
    )
}